import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import IconButton, { ICON_BUTTON_ICONS, ICON_BUTTON_TYPES } from '../buttons/IconButton';
import { useStore } from '../../store/store';

/**
 * TD-2352 — "Show data sources" toggle rendered as a header action icon (styled like the other
 * header icons). Filled/active when on, outline when off; tooltip "Show data sources". Clicking
 * flips the global data-source headline colouring (UtilsStore, persisted to localStorage; the body
 * class + floating legend are driven by DataSourceFloatingLegend).
 */
const DataSourceToggleIcon = observer(({ id = 'data-sources-btn', wrapClassName = '' } = {}) => {
  const { utilsStore } = useStore();
  const on = utilsStore.showDataSources;

  return (
    <IconButton
      id={id}
      type={ICON_BUTTON_TYPES.BLUE}
      icon={ICON_BUTTON_ICONS.INFO_CIRCLE}
      filled={on}
      wrapClassName={wrapClassName}
      tooltipText="Show data sources"
      onClick={() => utilsStore.setShowDataSources(!on)}
    />
  );
});

DataSourceToggleIcon.propTypes = {
  id: PropTypes.string,
  wrapClassName: PropTypes.string
};

export default DataSourceToggleIcon;
